<template>
  <div class="row search">
    <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
      <form @submit.prevent="handleSubmit">
        <div>
          <vue-autosuggest
            :suggestions="results"
            :getSuggestionValue="getSuggestionValue"
            :shouldRenderSuggestions="shouldRenderSuggestions"
            :input-props="{
              id: 'autosuggest__input',
              placeholder: 'Search',
              class: 'form-control',
            }"
            @input="fetchResults"
            @selected="selectHandler"
            v-model="query"
            ref="autosuggest"
          >
            <template slot="before-suggestions">
              <div
                v-if="loading"
                class="spinner-border search__loading search__loading--results"
                role="status"
                aria-label="Loading"
              ></div>
            </template>

            <template slot-scope="{ suggestion }">
              <a
                v-show="!loading"
                href=""
                class="my-suggestion-item"
                v-html="suggestion.item.highlight"
              ></a>
            </template>

            <template slot="after-suggestions">
              <div class="search__related">
                <h3>{{ relatedHeading }}</h3>
                <div
                  v-show="loading"
                  class="spinner-border search__loading"
                  role="status"
                  aria-label="Loading"
                ></div>
                <ul v-show="!loading">
                  <li
                    v-for="(item, idx) in suggestions"
                    :key="`suggestion-${idx}`"
                  >
                    <img v-if="item.thumbnail" :src="item.thumbnail" />
                    <span
                      ><a
                        @mouseup.stop
                        :href="item.url"
                        v-html="item['post_title']"
                      ></a
                    ></span>
                  </li>
                </ul>
              </div>
            </template>
          </vue-autosuggest>
        </div>

        <button class="button--hasIcon" aria-label="Search">
          <lms-icon icon-name="search" width="30" height="30"></lms-icon>
        </button>
      </form>
    </div>
  </div>
</template>

<script lang="js">
import {mapState} from "vuex";
import axios from "axios";
import lmsIcon from "../icon/icon.vue";
import {VueAutosuggest} from 'vue-autosuggest';

export default {
  name: 'lms-search',
  components: {
    lmsIcon,
    VueAutosuggest
  },
  props: {
    endpoint: {
      type: String,
      default: "/wp-json/it/v1/search-auto"
    },
    relatedHeading: {
      type: String,
      default: "Popular products",
    },
    searchPage: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      query: this.$store.state.searchQuery,
      results: [],
      selected: "",
      timeout: null,
      suggestions: [],
      limit: 10,
      loading: false,
    }
  },
  computed: mapState(['searchOpen', 'navOpen', 'drawerOpen']),
  watch: {
    /**
     * Watch for the global 'searchOpen' state to change.
     * If it opens, focus on the input. if not, clear out
     * the suggestions and search query
     */
    searchOpen(newValue) {
      if (newValue) {
        this.$refs.autosuggest.$el.querySelector("input").focus();
        if (this.$breakpoint.mdAndDown) {
          document.body.style.overflow = 'hidden';
        }
      } else {
        document.body.style.overflow = 'auto';
        this.suggestions = [];
        this.query = '';
      }
    },
    /**
     * When the query changes, also update the url param
     * and the searchQuery in the global state
     * @param {string} newValue
     */
    query(newValue) {
      const newObject = {s: newValue};
      this.$router.replace({query: newObject});
      this.$store.state.searchQuery = newValue;
    }
  },
  mounted() {

  },
  methods: {
    /**
     * If the form is submitted, go to the main search results page
     */
    handleSubmit() {
      document.location.href = `${this.searchPage}?s=${this.query}`;
    },
    /**
     * Handle clicking on the input
     */
    clickHandler() {

    },
    /**
     * Handle clicks on a suggested result
     */
    selectHandler(item) {
      document.location.href = item.item.url;
    },
    /**
     * Fetch search results via Wordpress JSON endpoint
     */
    fetchResults() {
      const vm = this;
      clearTimeout(vm.timeout);
      vm.timeout = setTimeout(() => {
        vm.loading = true;
        axios.get(`${vm.endpoint}/${vm.query}`)
            .then((response) => {
              vm.results = [{data: response.data.posts}];
              vm.suggestions = response.data.suggestions

              // If there are more matches than the auto-suggest shows,
              // Append an entry that will show a "see more" link that
              // goes to the full search page
              if (response.data['found_posts'] > 5) {
                response.data.posts.push({highlight: 'See more results', url: this.searchPage + '?s=' + this.query});
                // if there are no matches, but there are suggestions
                // to display, show a "no results" message
              } else if (response.data['found_posts'] === 0 && vm.suggestions.length !== 0) {
                response.data.posts.push({
                  highlight: 'Sorry, no results found.',
                  url: this.searchPage + '?s=' + this.query
                })
              }
              this.$nextTick(() => {
                vm.loading = false;
              })
            })
            .catch((error) => {
              // handle error
              console.log(error);
            });
      }, 250);
    },
    /**
     * Set the value of the search input when a selection is made
     */
    getSuggestionValue(suggestion) {
      return suggestion.item['post_title'];
    },
    /**
     * Determine if the suggestion dropdown should show.
     * Note that "size" represents the number of search results found
     * @param {string} size
     * @param {boolean} loading
     * @returns {boolean|boolean}
     */
    shouldRenderSuggestions(size, loading) {
      return size > 0 && !loading && (this.query !== "" && this.query.length > 3);
    },
  },
}
</script>
